/**
 * Mappa la chiave di un output di un servizio asincrono in un campo
 * flattened. Utilizzato per la gestione dei campi annidati.
 */
export function mapAsyncServiceField(key: string) {
  return key.split('.').join('@@DOT@@');
}
